
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download/mobile-app-technology-chaos-map-2025/done",
      function () {
        return require("private-next-pages/download/mobile-app-technology-chaos-map-2025/done/index.tsx");
      }
    ]);
  